"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("@mui/styles");
var useStyles = (0, styles_1.makeStyles)({
    carouselContainer: {
        width: '100%',
        margin: '0 auto',
        overflow: 'hidden'
    },
    carousel: {
        overflow: 'hidden',
        height: '100%'
    }
});
var groupSlides = function (slides, slidesToShow) {
    var groupedByVisibleCount = [];
    for (var i = 0; i < slides.length; i += slidesToShow) {
        groupedByVisibleCount.push(slides.slice(i, i + slidesToShow));
    }
    return groupedByVisibleCount;
};
var SlideShow = function (_a) {
    var slides = _a.slides, interval = _a.interval, groupSlideCount = _a.groupSlideCount;
    if (slides.length === 0 || groupSlideCount === 0) {
        return null;
    }
    var groupedSlides = groupSlides(slides, groupSlideCount);
    var classes = useStyles();
    var _b = (0, react_1.useState)(0), currentIndex = _b[0], setCurrentIndex = _b[1];
    (0, react_1.useEffect)(function () {
        var nextSlide = function () {
            setCurrentIndex(function (prevIndex) { return (prevIndex < groupedSlides.length - 1 ? prevIndex + 1 : 0); });
        };
        var intervalInMilliSeconds = interval * 1000;
        var intervalId = setInterval(function () {
            nextSlide();
        }, intervalInMilliSeconds);
        return function () {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [interval, groupedSlides]);
    return (react_1.default.createElement("div", { className: classes.carouselContainer },
        react_1.default.createElement("div", { className: classes.carousel }, groupedSlides[currentIndex])));
};
exports.default = SlideShow;
//# sourceMappingURL=SlideShow.js.map